import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Intro from "@/components/Intro";
import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import ExecutiveMaterials from "@/pages/ExecutiveMaterials";

const Layout = ({ children }) => {
  const location = useLocation();
  /* Cinematic intro: homepage only, once per browsing session, skipped for
     reduced-motion visitors and for direct deep links (shared #section URLs) */
  const [introDone, setIntroDone] = useState(() => {
    try {
      if (window.location.pathname !== "/") return true;
      if (window.location.hash) return true;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
      return sessionStorage.getItem("cb_intro_seen") === "1";
    } catch { return true; }
  });
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }

    const id = location.hash.replace("#", "");
    const scrollToHash = (smooth) => {
      const el = document.getElementById(id);
      if (!el) return;
      const target = Math.max(0, el.getBoundingClientRect().top + window.scrollY - 72);
      if (window.__lenis) {
        window.__lenis.scrollTo(target, smooth ? { duration: 1.1 } : { immediate: true, force: true });
      } else {
        window.scrollTo({ top: target, behavior: smooth ? "smooth" : "instant" });
      }
    };

    const timers = [100, 1800, 3600, 6500].map((delay, i) => setTimeout(() => scrollToHash(i === 0), delay));
    return () => timers.forEach(clearTimeout);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-[var(--cb-bg)] text-[var(--cb-text)]">
      {!introDone && <Intro onFinish={() => setIntroDone(true)} />}
      <Navbar />
      <main className="pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); delete window.__lenis; lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/executive-materials" element={<ExecutiveMaterials />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
